import { render, staticRenderFns } from "./BulkDeleteConfirmationModal.vue?vue&type=template&id=3bf9bdc3"
import script from "./BulkDeleteConfirmationModal.vue?vue&type=script&lang=js"
export * from "./BulkDeleteConfirmationModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports